import { render } from "./downloadsPcIndex.vue?vue&type=template&id=9b7b4612"
import script from "./downloadsPcIndex.vue?vue&type=script&lang=js"
export * from "./downloadsPcIndex.vue?vue&type=script&lang=js"

import "./downloadsPcIndex.vue?vue&type=style&index=0&id=9b7b4612&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__